function toUpperCase(val: string): string {
  if (!val) {
    return null;
  }

  return val.toString().toUpperCase();
}

export { toUpperCase };
